<template>
    <v-form ref="period-execution-form" v-model="formValid" @input="handleFormInput">
        <v-combobox
                ref="period-execution-combobox"
                label="Due time (days)"
                :search-input.sync="search"
                :disabled="disabled"
                v-model="selectedDays"
                :rules="periodExecutionRules"
                :items="formattedAvailablePeriods"
                @update:search-input="handlePeriodExecutionSearch"
                @input="handlePeriodExecutionChanged"
                @keyup.enter.native="handleUpdatePeriodExecution"
        >
        </v-combobox>
        <!--<v-text-field class="form-item" v-model="days" label="Days"></v-text-field>-->
        <!--<v-text-field class="form-item ml-2" v-model="hours" label="Hours"></v-text-field>-->
    </v-form>
</template>

<script>
    import moment from 'moment'
    import _ from 'lodash'
    import {isNumeric} from '../../helpers/numbers'

    export default {
        name: "PeriodExecutionSelector",
        props: {
            availablePeriods: Array,
            periodExecution: Number,
            disabled: Boolean
        },
        data() {
            const {days} = this.formatPeriodExecution(_.get(this, 'periodExecution', 216))
            let formattedAvailablePeriods = []

            for (let period of this.availablePeriods) {
                let periodInDays = moment.duration(period, 'hours').format('D')
                formattedAvailablePeriods.push(periodInDays)
            }

            if (_.indexOf(formattedAvailablePeriods, days) < 0 && days > 0) {
                formattedAvailablePeriods.push(days)
            }

            return {
                formValid: false,
                //days: selectedPeriodExecutionDays,
                //hours: selectedPeriodExecutionHours,
                search: null,
                selectedDays: days,
                formattedAvailablePeriods: formattedAvailablePeriods,
                periodExecutionRules: [
                    function (v) {
                        return isNumeric(v) || 'Value must be numeric'
                    },
                    function (v) {
                        return isNumeric(v) && parseInt(v) > 0 || "Value must be positive"
                    }
                ]
            }
        },
        computed: {},
        methods: {
            handleFormInput(value) {
                this.$emit('validation-changed', value)
            },
            handlePeriodExecutionChanged(value) {
                this.$emit('changed', this.getValue())
            },
            isValid() {
                return this.formValid
            },
            validate(force = false) {
                return this.$refs['period-execution-combobox'].validate(force)
            },
            getValue() {
                return this.selectedDays * 24
            },
            handlePeriodExecutionSearch(val) {
                this.selectedDays = val
                const validationResult = this.validate()

                if (validationResult) {
                    this.$emit('changed', this.getValue())
                }
            },
            handleUpdatePeriodExecution() {
                this.$nextTick(() => {
                    this.$refs['period-execution-combobox'].blur()
                })
            },
            formatPeriodExecution(periodExecution) {
                if (!periodExecution) {
                    return {days: null, hours: null}

                }
                const selectedPeriodExecution = moment.duration(_.cloneDeep(periodExecution), 'hours')

                const selectedPeriodExecutionDays = selectedPeriodExecution.format('D')
                const selectedPeriodExecutionHours = selectedPeriodExecution.format('H')

                return {days: selectedPeriodExecutionDays, hours: selectedPeriodExecutionHours}
            }
        },
        mounted() {
            //this.$refs['period-execution-form'].resetValidation()
        },
        watch: {
            periodExecution(val, prevVal) {
                const {days} = this.formatPeriodExecution(val)
                this.selectedDays = days
            }
        }
    }
</script>

<style scoped>
    .form-item {
        width: 50px;
        display: inline-block;
    }
</style>